import classes from './QuickStartVideos.module.scss';

// actions
import { showVideo, showQuickstartVideos } from 'actions/flinkPlayActions';

// redux
import { connect } from 'react-redux';

//
import PropTypes from 'prop-types';
import GameModal from '../GameModal/GameModal';
import { filesURL, imagesURL } from 'config';
import { GO } from 'consts/buttons';
import { isMobileAppRuntime } from 'utils';

const QuickStartVideos = ({ translate, language, allVideos, ...props }) => {
  const { showQuickstartVideos, showVideo } = props;
  const videos = allVideos[language.code] || [];
  const mobileRuntime = isMobileAppRuntime();
  const playButtonImage = (props.globalButtons || []).find((button) => button?.alias === GO)?.imageFilename;
  const playIconUrl = playButtonImage ? `${imagesURL}/GlobalButtons/${playButtonImage}` : ''; 

  const showQuickStartVideo = (filename) => {
    showVideo({
      src: `${filesURL}/Files/animations/QuickStart/${language.name}/${filename}`,
      callback: (ref) => {
        if (!ref)
          return showVideo(null);
        return ref.current?.showPreview();
      },
    });
  }

  return (
    <GameModal
      title={translate(1320, 'QuickStart Videos')}
      buttons={[
        {
          title: translate(80, 'Close'),
          clickHandler: showQuickstartVideos.bind(this, false),
          // icon: `${imagesURL}/Images/Help/Close50.png`,
        },
      ]}
      innerClassnames={[
        classes.fontWrapper,
        classes.modal,
        ...(mobileRuntime ? [classes.mobileQuickStart] : []),
      ]}
      outerClassnames={mobileRuntime ? [classes.mobileModal] : []}
      contentClassnames={mobileRuntime ? [classes.mobileContent] : []}
      titleClassnames={mobileRuntime ? [classes.mobileTitle] : []}
      buttonsClassnames={mobileRuntime ? [classes.mobileActions] : []}
    >
      <div className={classes.grid}>
        {videos?.map((video) => mobileRuntime ? (
          <li key={video.value}>
            <button
              type="button"
              className={classes.videoButton}
              onClick={showQuickStartVideo.bind(this, video.value)}
            >
              <span className={classes.playIcon} aria-hidden="true">
                {playIconUrl ? <img src={playIconUrl} alt="" /> : null}
              </span>
              <span className={classes.videoTitle}>{translate(video.label, '', true)}</span>
            </button>
          </li>
        ) : (
          <li key={video.value} onClick={showQuickStartVideo.bind(this, video.value)}>
            {translate(video.label, '', true, false, '', true)}
          </li>
        ))}
      </div>
    </GameModal>
  );
}

QuickStartVideos.propTypes = {
  language: PropTypes.object.isRequired,
  translate: PropTypes.func.isRequired,
  allVideos: PropTypes.object.isRequired,
  globalButtons: PropTypes.array,
};

const mapStateToProps = ({ 
  status, 
  flinkPlay,
  common,
}) => ({
  translate: flinkPlay.solutionTranslate || status.translate,
  allVideos: common.config?.loginPageDocuments?.quickStart || {},
  globalButtons: common.globalButtons || [],
});

const mapDispatchToProps = {
  showVideo,
  showQuickstartVideos,
};

export default connect(mapStateToProps, mapDispatchToProps)(QuickStartVideos);
